import React from "react";
import { Flex, Image, Text } from "@chakra-ui/react";
import Logo from "../../../assets/img/brand-logo-white.svg";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  return (
    <Flex align="stretch" direction="column" px="4px">
      <Flex align="center" gap="10px" mb="14px" w="100%">
        <Image src={Logo} h="36px" w="auto" alt="Natural Remedies" data-no-image-preview />
        <Text
          color="white"
          fontFamily="'IBM Plex Sans', sans-serif"
          fontWeight="500"
          fontSize="16px"
          letterSpacing="0.2px"
          lineHeight="1.2"
        >
          Natural Remedies
        </Text>
      </Flex>
      <HSeparator mb="12px" bg="rgba(255, 255, 255, 0.12)" />
    </Flex>
  );
}

export default SidebarBrand;
